import { DaymapInfiniteQuery as m } from "../daymapQuery.js";
var i;
((n) => {
  class a extends m {
    constructor({ studentId: e, notificationsPerPage: r }) {
      super(
        ["notifications", e, r],
        { studentId: e, notificationsPerPage: r },
        "",
        null,
        {
          infiniteQueryUrl: (t) => `/lms/api/coms/notifications?pageNum=${t}&itemsPerPage=${r}${e ? `&studentId=${e}` : ""}`,
          initialPageParam: 1,
          getNextPageParam: (t, l) => {
            if (t.length === r)
              return l.length + 1;
          },
          refetchInterval: 3e4,
          refetchOnMount: !0
        }
      );
    }
  }
  n.get = a;
})(i || (i = {}));
export {
  i as notifications
};
//# sourceMappingURL=index.js.map
